<div
    class="oval"
    [class.ovalSelected]="theme === 'bootstrap'"
    [ngClass]="[containerClass ? containerClass : '']"
    (click)="toggleTheme()">
    <div
        class="button"
        [ngClass]="{ buttonSelected: theme === 'bootstrap' }"></div>
</div>
